import { type CatalogValue } from '../../configuration/catalogs/models/Catalog';
import type { CatalogModel } from '../../configuration/catalogs/models/Catalog';

export interface TaxpayerPayment {
  tin: string;
  name: string;
  paymentDate: Date;
  taxCode: string;
  amount: number;
}
export interface PaymentsReceived {
  id: string;
  uploadNumber: string;
  attachment: string;
  state: string;
  taxCollectorId: string;
  taxCollector: CatalogModel;
} /* --- STATE --- */

export interface DetailPaymentsReceived {
  id: string;
  paymentReceivedId: string;
  date?: Date;
  CurrencyId?: string;
  currencyCode?: string;
  amount?: number;
  taxpayer?: string;
  bankCost?: number;
  reference?: string;
  swift: string;
  recordIndex: number;
}
export interface ExcelColumnDefinition {
  header: string;
  type: string;
  description: string;
}
export interface TaxReturnTabParams {
  taxReturnId: string;
  tab: string;
}

export interface ReportState {}

export type ContainerState = ReportState;
export interface PaymentFileUploadResponse {
  id: string;
}

export interface ReconciliationOfPaymentItemRequest {
  taxReturnPaymentId: string;
  paymentsReceivedId: string;
}

export interface ReconciliationOfPaymentRequest {
  items: Array<ReconciliationOfPaymentItemRequest>;
}

export interface PaymentReceived {
  id: string;
  uploadNumber: string;
  attachment: string;
  state: string;
  taxCollectorId: string;
  taxCollector?: any;
  createdDate: Date;
}
export interface PaymentsReceivedDetail {
  id: string;
  paymentReceivedId: string;
  date: Date;
  currencyId: string;
  currencyCode: string;
  amount: number;
  taxpayer: string;
  bankCost: number;
  reference: string;
  swift: string;
  recordIndex: number;
  validationResults: Array<any>;
  validationResultsText: string;
  paymentReceived: PaymentReceived;
}
export interface ReconciliationOfPayment {
  id: string;
  taxReturnPaymentId: string;
  paymentsReceivedId: string;
  paymentsReceived: PaymentsReceivedDetail;
}

export interface TaxReturnPayment {
  id?: string;
  taxReturnId: string;
  tin: string;
  taxReturnNumber: string;
  period: number;
  taxReturnType: string;
  currencyId: string;
  currency?: CatalogModel;
  paymentMethodId: string;
  paymentMethod?: CatalogModel;
  attachment?: any;
  amount: number;
  state?: string;
  paymentReference: string;
  paymentNumber: string;
  reason?: string | null;
  attachmentId: string;
  createdDate?: Date;
  paymentDate?: Date;
  swift: string;
  reconciliationOfPayments?: ReconciliationOfPayment;
}

export interface TaxReturnPaymentByJurisdiction extends TaxReturnPayment {
  jurisdictionId: string;
  jurisdictionName: string;
}

export interface ReconciliationOfPaymentItemRequest {
  taxReturnPaymentId: string;
  paymentsReceivedId: string;
}

export interface ReconciliationOfPaymentRequest {
  items: Array<ReconciliationOfPaymentItemRequest>;
}

export interface PaymentReceived {
  id: string;
  uploadNumber: string;
  attachment: string;
  state: string;
  taxCollectorId: string;
  taxCollector?: any;
  createdDate: Date;
}
export interface PaymentsReceivedDetail {
  id: string;
  paymentReceivedId: string;
  date: Date;
  currencyId: string;
  currencyCode: string;
  amount: number;
  taxpayer: string;
  bankCost: number;
  reference: string;
  swift: string;
  recordIndex: number;
  validationResults: Array<any>;
  validationResultsText: string;
  paymentReceived: PaymentReceived;
}
export interface ReconciliationOfPayment {
  id: string;
  taxReturnPaymentId: string;
  paymentsReceivedId: string;
  paymentsReceived: PaymentsReceivedDetail;
}

export const paymentFileDetailsSearch = (paymentFileId: string) => ({ paymentFileId });

export interface PaymentDeclarationContent {
  taxReturnId: string;
  currencyId: string;
  paymentMethodId: string;
  amount: number;
  paymentReference: string;
  attachmentId?: string;
  paymentDate: Date;
  swift: string;
}

export interface PaymentDeclaration {
  id: string;
  paymentNumber: string;
  taxReturnId: string;
  paymentMethod: CatalogValue;
  currency: CatalogValue;
  tin: string;
  taxReturnNumber: string;
  period: number;
  swift: string;
  paymentDate: Date;
  attachmentId: string;
  status: string;
  amount: number;
}

export interface PaymentTransaction {
  id: string;
  paymentFileId: string;
  date?: Date;
  currencyId?: string;
  currencyCode: string;
  amount?: number;
  taxpayer: string;
  bankCost?: number;
  reference: string;
  swift: string;
  recordIndex: number;
}

export interface PaymentSummary extends PaymentDeclaration {
  paymentTransaction?: PaymentTransaction;
}

export interface PaymentFilter {
  id?: string;
  tin?: string;
  status?: string;
  taxpayerId?: string;
  period?: number;
  dateFrom?: Date;
  dateTo?: Date;
  amountFrom?: number;
  amountTo?: number;
}
